<form [signalForm]="configForm" class="flex min-h-0 flex-1 flex-col gap-6 overflow-y-auto px-4 py-4">
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Configuration
    </h3>
    <lib-signal-text-field
      label="Label"
      [formField]="configForm.label" />
    <lib-signal-text-field
      label="Help text"
      placeholder="Shown under the field"
      [formField]="configForm.helpText" />
    <lib-signal-date-field
      label="Minimum date"
      [formField]="configForm.minDate" />
    <lib-signal-date-field
      label="Maximum date"
      [formField]="configForm.maxDate" />
    <div class="flex flex-col gap-3">
      <lib-signal-checkbox
        label="Disable past dates"
        hint="Prevent selecting dates before today"
        [formField]="configForm.disablePast" />
      <lib-signal-checkbox
        label="Disable future dates"
        hint="Prevent selecting dates after today"
        [formField]="configForm.disableFuture" />
    </div>
    <lib-signal-date-field
      label="Default date"
      hint="Automatically filled when the form opens. Respondents can change it."
      [formField]="configForm.defaultDate" />
    <lib-signal-dropdown
      label="Date format"
      [items]="dateFormatOptions"
      valuePath="value"
      displayPath="label"
      [formField]="configForm.dateFormat" />
  </section>
  <section class="flex flex-col gap-3">
    <h3 class="text-xs font-semibold uppercase tracking-wide text-slate-400">
      Validators
    </h3>
    <lib-signal-checkbox
      label="Required"
      hint="Respondent must select a date"
      [formField]="configForm.required" />
    <lib-signal-text-field
      label="Custom error message"
      placeholder="Shown when validation fails"
      [formField]="configForm.customMessage" />
  </section>
</form>
